<template>
  <div class="p-md">
    <div class="app-block p-md is-half">
      <h3 class="title is-3 has-text-weight-light">
        <strong>Étape de candidature</strong>
      </h3>
      <div class="">
        <div class="column application-status">
          <span>{{ applicationStatus }}
            <span v-if="application.accepted && !registered">
              <a
                v-scroll-to="'.registration-block'"
                href="#"
              >Veuillez désormais procéder à l'inscription définitive</a>
            </span>
          </span>

          <div v-if="registered">
            <a
              :href="'/admission/doc/' + application.id"
              title="Confirmation d'inscription"
            >
              Confirmation de votre inscription</a>
          </div>
        </div>
      </div>
      <progress
        v-if="!registeredCandidate(candidate.id)"
        class="progress is-small"
        :value="completion"
        max="100"
      >
        <span>{{ completion }}%</span>
      </progress>
    </div>
    <br>

    <div
      v-if="choice"
      class="app-block p-md"
    >
      <h3 class="heading-line title is-5 has-text-weight-light">
        <span :class="'training-choice training-choice-'+schoolSlug">{{ training }}  <span
          v-if="training_option"
        >- {{ training_option }}</span></span>
      </h3>
      <h3 class="m-t-md">
        <i>{{ campus }} {{ scholarYear }}</i>
      </h3>
      <div v-if="currentScholarYear && choice.scholar_year === currentScholarYear || !choice.fees">
        <h5>
          <strong>Frais de scolarité annuels:</strong> <i>veuillez appeler le 04 67 920 910 pour un devis
            personnalisé</i>
        </h5>
      </div>
      <div v-else-if="choice.scholar_year === 'other'" />
      <div v-else>
        <h5 v-if="choice.has_available_places">
          <span v-if=" choice.fees.registered_fees && registeredCandidate(candidate.id) && applicationLog && !applicationLog.canceled_application">
            <strong>Frais de scolarité annuels :</strong> {{ choice.fees.registered_fees }} euros
          </span>
          <span v-else>
            <strong>Frais de scolarité annuels :</strong> {{ choice.fees.fees }} euros
          </span>
        </h5>
        <h5 v-else>
          <strong
            v-if="!registered"
            class="has-text-danger"
          >Les inscriptions sont closes pour cette formation et ce campus, contactez le 09 80 80 80 75</strong>
        </h5>
      </div>
      <div v-if="choice.training && choice.training.offers.length">
        <hr>
        <h5>
          <div>
            Consulter nos offres complémentaires :
          </div>
          <div v-for="offer in choice.training.offers">
            <a
              target="_blank"
              @click="displayOffer(offer, choice)"
            >
              - {{ offer.name.fr }}
            </a>
          </div>
        </h5>
      </div>
      <div class="has-text-right">
        <button
          v-if="!accepted || (hasRegisteredApplication && !registered)"
          class="button"
          @click="edit"
        >
          Modifier
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import _ from "lodash";

export default {
  props: {
    schoolSlug: {type: String},
    candidate: {type: Object},
    application: {type: Object},
    campuses: {type: Array},
    trainings: {type: Array},
    choices: {type: Array},

    completion: {type: Number}
  },
  data() {
    return {
      isLoading: '',
      citiesList: false,
      training: '',
      training_option: '',
      campus: '',
      choice: {},
    }
  },
  computed: {
    ...mapGetters('organization', [
      'currentScholarYear'
    ]),
    ...mapGetters({
      registeredCandidate: 'candidate/hasRegisteredApplication'
    }),
    registered() {
      return this.application.registration && this.application.registration.registered_candidate
    },
    accepted() {
      return this.application.accepted
    },
    isRegisteredCandidate() {
      return this.candidate.isRegisteredCandidate
    },
    hasRegisteredApplication() {
      return this.candidate.hasRegisteredApplication
    },
    scholarYear() {
      if (!_.isEmpty(this.application.choices)) {
        switch (this.application.choices[0].scholar_year) {
          case 'other':
            return ''
          default:
            return '- ' + this.choice.scholar_year
        }
      }
    },
    applicationStatus() {
      if (!this.application.application_complete && !this.application.accepted) {
        return 'Candidature en cours de saisie'
      } else if (this.application.accepted) {

        if (this.application.registration && this.application.registration.registered_candidate) {
          return 'Vous êtes ' + (this.candidate.gender === 'F' ? 'inscrite' : 'inscrit')
        } else {
          return 'Votre candidature est acceptée.'
        }
      } else {
        return 'Candidature envoyée'
      }
    },
    applicationLog() {
      if (!this.candidate.application_log) {
        return null;
      }

      let logs = this.candidate.application_log.filter(application => application.id !== this.application.id);

      if (logs.length === 0) {
        return null;
      }

      let orderedLogs = _.orderBy(logs, log => new Date(log.accepted_date), 'desc');

      return orderedLogs[0];
    },

  },
  methods: {
    ...mapActions({
      sendApplication: 'candidate/sendApplication'
    }),
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },
    displayOffer(offer, choice) {
      this.$router.push({name: 'eshop-offer', params: {
          school: choice.school_slug,
          categoryId: offer.categoryId,
          offerId: offer.id,

        }})
    },
    edit: function () {
      this.$emit('edit')
    },
  },
  created() {


    this.choice = this.application.choices[0]

    this.training = this.choice.training_name

    if (this.choice.training_option_name) {
      this.training_option = this.choice.training_option_name
    }
    this.campus = this.choice.campus_name


  }
}
</script>

<style scoped>
.progress {
  border-radius: 3px;
}
</style>
